<template>
  <div class="group flex w-full items-center justify-between py-[6px] pl-[28px] pr-[16px] transition-colors duration-150 hover:bg-[--v3-input-lists-inputlistbg]">
    <TagListing :name :is-small="true" />
    <div class="cursor-pointer" @click="$emit('delete')">
      <Icon name="trash" class="size-[14px] text-[--v3-button-warningbuttonbg] opacity-0 transition-opacity  duration-150 group-hover:opacity-100" />
    </div>
  </div>
</template>

<script lang="ts" setup>
import Icon from '@/common/components/atoms/Icon';
import TagListing from '@/common/components/atoms/TagListing';

defineProps<{
  name: string
}>();

defineEmits<{
  delete: []
}>();
</script>

<style scoped>
/* Add your styles here */
</style>
